export default "__VITE_ASSET__CPuMbJov__"